export class SearchResultView {
    public priceId: string;
    public no: number;
    public priceCode: string;
    public priceName: string;
    public status: string;
    public commitBy: string;
    public commitDateTime: string;
}